/* ============================================================
   assets/territory-carts.js
   ------------------------------------------------------------
   Conversation "design produit" (27/09), valide par Isabelle.

   Contexte : un panier par territoire. Chaque territoire est un
   Market Shopify avec son sous-domaine (guadeloupe.shoplokal.online,
   dominica.shoplokal.online...) et Shopify garde un panier distinct
   par sous-domaine. Quitter un territoire conserve son panier ; on
   le retrouve tel quel en revenant (comportement natif, voulu).

   Probleme UX : en changeant de territoire, l'acheteur voit un
   panier vide et peut croire avoir perdu ses articles.

   Ce script : memorise le nombre d'articles du panier du territoire
   courant dans un cookie commun a tout shoplokal.online, pour que
   le selecteur de territoire (header, conversation "theme header")
   puisse afficher un compteur UNIQUEMENT pour les territoires dont
   le panier n'est pas vide (decision d'Isabelle, 27/09).

   Cookie : sl_territory_carts = {"guadeloupe":2,"dominica":1}
   (encode en URI). Un territoire au panier vide est retire.
   Cle = sous-domaine ; "root" pour shoplokal.online sans sous-domaine.

   API pour le header :
     window.SLTerritoryCarts.all()          -> {"guadeloupe": 2, ...}
     window.SLTerritoryCarts.count("dominica") -> 1 (0 si vide)
     window.SLTerritoryCarts.current        -> "guadeloupe"
     evenement document "sl:territory-carts:updated" (detail = all())
   ============================================================ */
(function () {
  var ROOT_DOMAIN = 'shoplokal.online';
  var COOKIE = 'sl_territory_carts';
  var MAX_AGE = 60 * 60 * 24 * 30; // 30 jours, comme le panier Shopify

  var host = window.location.hostname;
  var onShoplokal = host === ROOT_DOMAIN || host.slice(-(ROOT_DOMAIN.length + 1)) === '.' + ROOT_DOMAIN;
  var current = host === ROOT_DOMAIN ? 'root' : host.split('.')[0];

  function readAll() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!match) return {};
    try {
      var data = JSON.parse(decodeURIComponent(match[1]));
      return data && typeof data === 'object' ? data : {};
    } catch (e) {
      return {};
    }
  }

  function writeAll(data) {
    // Hors shoplokal.online (apercu *.myshopify.com, shopifypreview...) :
    // un cookie de domaine parent est impossible, on ne fait rien.
    if (!onShoplokal) return;
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(data)) +
      '; domain=.' + ROOT_DOMAIN + '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax; Secure';
  }

  function setCount(count) {
    var data = readAll();
    count = parseInt(count, 10) || 0;
    if (count > 0) {
      data[current] = count;
    } else {
      delete data[current];
    }
    writeAll(data);
    document.dispatchEvent(new CustomEvent('sl:territory-carts:updated', { detail: data }));
  }

  function refreshFromCart() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setCount(cart.item_count); })
      .catch(function () {});
  }

  window.SLTerritoryCarts = {
    current: current,
    all: readAll,
    count: function (territory) { return parseInt(readAll()[territory], 10) || 0; }
  };

  // 1. Au chargement : nombre d'articles rendu par Shopify (layout/theme.liquid)
  if (window.theme && typeof window.theme.cartCount === 'number') {
    setCount(window.theme.cartCount);
  } else {
    refreshFromCart();
  }

  // 2. Apres ajout au panier ou rafraichissement (evenements Warehouse)
  document.documentElement.addEventListener('product:added', refreshFromCart);
  document.documentElement.addEventListener('cart:refresh', refreshFromCart);

  // 3. Retour arriere navigateur (page servie depuis le cache)
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshFromCart(); });

  // 4. Titre de la page panier : "Mon panier" + territoire en sous-titre
  //    Isabelle (27/09) : le territoire doit apparaitre dans le titre
  //    du panier. Version 1 "Mon panier · Guadeloupe" sur une ligne :
  //    illisible avec un nom long (Saint-Vincent-et-les-Grenadines
  //    coupe en plein mot sur 360px). Version validee : titre court
  //    + territoire en sous-titre (pastille corail, texte teal).
  //    Le titre vient de la section Webkul (wk-cart.liquid, texte
  //    anglais en dur) : on le remplace ici, sans modifier le fichier
  //    Webkul. Noms = Markets Shopify (27/09).
  //    shoplokal.online sans sous-domaine : Isabelle (27/09) ne voyait
  //    pas le territoire alors que le selecteur du header affiche
  //    "Guadeloupe" -> territoire par defaut = Guadeloupe (territoire
  //    de lancement), coherent avec le header.
  //    Styles en ligne : evite de dupliquer le sous-titre dans le CSS.
  var TERRITORY_NAMES = {
    guadeloupe: 'Guadeloupe', martinique: 'Martinique', guyane: 'Guyane',
    reunion: 'La Réunion', haiti: 'Haïti', jamaica: 'Jamaïque',
    anguilla: 'Anguilla', sintmaarten: 'Sint Maarten', stmartin: 'Saint-Martin',
    stbarths: 'Saint-Barthélemy', antiguabarbuda: 'Antigua-et-Barbuda',
    republicadominicana: 'République dominicaine', stkittsnevis: 'Saint-Kitts-et-Nevis',
    montserrat: 'Montserrat', dominica: 'Dominique', stlucia: 'Sainte-Lucie',
    stvincent: 'Saint-Vincent-et-les-Grenadines', grenada: 'Grenade', barbados: 'Barbade'
  };

  function decorateCartTitle() {
    if (!window.theme || window.theme.pageType !== 'cart') return;
    var title = document.querySelector('.wk-main-conent__split-cart h1');
    if (!title || title.getAttribute('data-sl-title')) return;
    title.textContent = 'Mon panier';
    title.setAttribute('data-sl-title', '1');

    var DEFAULT_TERRITORY = 'guadeloupe';
    var name = TERRITORY_NAMES[current] || (current === 'root' ? TERRITORY_NAMES[DEFAULT_TERRITORY] : null);
    if (!name) return;
    var centered = !!title.closest('#EmptyCart');
    var sub = document.createElement('p');
    sub.className = 'sl-cart-territory';
    sub.style.cssText = 'display:flex;align-items:center;gap:6px;margin:0 0 4px;' +
      'font-family:var(--text-font-family);font-size:14px;font-weight:500;line-height:1.3;color:#00665f;' +
      (centered ? 'justify-content:center;' : '');
    var dot = document.createElement('span');
    dot.setAttribute('aria-hidden', 'true');
    dot.style.cssText = 'flex:0 0 8px;width:8px;height:8px;border-radius:50%;background:#ef3f2e;';
    sub.appendChild(dot);
    sub.appendChild(document.createTextNode(name));
    title.insertAdjacentElement('afterend', sub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateCartTitle);
  } else {
    decorateCartTitle();
  }
})();
